export function minutesTrendKey(valueOrRow) {
  const isRow = valueOrRow && typeof valueOrRow === "object";
  const rawValue = isRow
    ? (valueOrRow.minutes_trend ?? valueOrRow.Minutes_Trend ?? valueOrRow["Minutes Trend"] ?? valueOrRow.minutesTrend ?? valueOrRow.min_trend ?? "")
    : valueOrRow;
  const raw = String(rawValue ?? "").trim().toUpperCase();
  if (!raw || ["NAN", "NULL", "NONE"].includes(raw)) return "";
  if (raw.includes("SURGING")) return "SURGING";
  if (raw.includes("RISING")) return "RISING";
  if (raw.includes("STABLE")) return "STABLE";
  if (raw.includes("COLLAPS")) return "COLLAPSING";
  if (raw.includes("FALLING")) return "FALLING";
  if (raw.includes("SOFT")) return "SOFT";
  if (raw.includes("VOLATILE")) return "VOLATILE";
  if (raw.includes("LOW")) return "LOW";
  const value = Number(rawValue);
  if (!Number.isFinite(value)) return raw;
  if (value >= 4) return "SURGING";
  if (value >= 1.5) return "RISING";
  if (value >= -1.5) return "STABLE";
  if (value <= -4) return "COLLAPSING";
  if (value <= -1.5) return "FALLING";
  return "SOFT";
}

export function nbaMinutesEvidence(row) {
  return { seasonMinutes: row?.mpg ?? null, recentMinutes: row?.minutes_recent_mpg ?? null, trend: row?.min_trend ?? null, trendKey: minutesTrendKey(row), volatility: row?.minutes_std ?? null, sample: row?.minutes_games_sample ?? null, sampleFlag: row?.minutes_flag ?? null, lineupMinutesOk: row?.lineup_minutes_ok ?? null };
}
